import { DataList, DataListItem } from '@brighte/form-components';
import { css } from '@emotion/css';
import { Accordion, AccordionItem } from '@spark-web/accordion';
import { Box } from '@spark-web/box';
import { LABELS } from '@utils';

interface FeeChargeDetailsProps {
  data?: DataListItem[];
}
function FeeChargeDetails({ data }: FeeChargeDetailsProps) {
  if (!data) {
    return null;
  }
  return (
    <Accordion type="single" collapsible={true} defaultValue={LABELS.FEES_AND_CHARGES}>
      <AccordionItem label={LABELS.FEES_AND_CHARGES} value={LABELS.FEES_AND_CHARGES}>
        <Box
          className={css({
            marginLeft: '-16px',
          })}
        >
          <DataList items={data} />
        </Box>
      </AccordionItem>
    </Accordion>
  );
}

export default FeeChargeDetails;
